<div class="w-full md:flex">
    <div id="snap-global-header-container" style="height: 56px">
        <snap-global-header theme="manage" class="fixed">
            <snap-logo product="snap-logo-manage" white variant="1line"></snap-logo>
            <slot />
            <snap-header-wrapper redirect-on-signin="/"
                                redirect-on-signout="https://snapraise.com/fanx"
                                show-app-switcher="true"
                                show-login-buttons="false"
            >
            </snap-header-wrapper>
        </snap-global-header>
    </div>
</div>